export default () => ({
  overlay: !1,
  searchValue: "",
  background: !1,
  helpMessage: !0,
  openHandler() {
    if (
      ((this.overlay = !0),
      (this.background = !0),
      this.bodyLock(),
      this.$refs.searchInput.focus(),
      "" === this.searchValue)
    ) {
      document.querySelector(
        ".klevu-fluid.klevuTarget.kuQuickSearchFacetedLayout"
      ).style.cssText = "display: none !important;";
    }
  },
  closeHandler() {
    (this.searchValue = ""),
      this.$refs.searchInput.blur(),
      (this.overlay = !1),
      (this.background = !1);
    (document.querySelector(
      ".klevu-fluid.klevuTarget.kuQuickSearchFacetedLayout"
    ).style.cssText = "display: none !important;"),
      this.bodyUnlock();
  },
  init() {
    this.$watch("searchValue", () => {
      const e = document.querySelector(
        ".klevu-fluid.klevuTarget.kuQuickSearchFacetedLayout"
      );
      "" !== this.searchValue
        ? ((this.helpMessage = !1),
          this.searchValue.length >= 3 &&
            e.classList.contains("visually-hidden") &&
            setTimeout(() => {
              e.classList.remove("visually-hidden");
            }, 250))
        : ((this.helpMessage = !0), e.classList.add("visually-hidden"));
    }); 
   /* const e = document.querySelector(
        ".klevu-fluid.klevuTarget.kuQuickSearchFacetedLayout"
      );
       setTimeout(() => {
              e.classList.remove("visually-hidden");
            }, 250))
    */
  },
});
